export const YJMedicine = {
  Header: {
    Title: 'お薬情報',
  },
  Label: {
    MedicineName: 'お薬の名前',
    GenericName: '一般名（有効成分）',
    IngredientsQuantities: '成分・分量',
    MakerName: 'メーカー',
    DosageForm: '剤型名称',
    Indication: '効果・効能',
    Dosage: '用法・用量',
    Precaution: '副作用',
    PrecautionOnUse: '服用上の注意',
    Storage: '保存方法',
    Notes: '＜ご利用にあたっての注意事項＞',
    NotesOfContent:
      '当サイトに掲載する薬の情報・画像（以下「薬剤情報等」といいます。）は「株式会社薬事日報社」の提供によるものです。\n当社は薬剤情報等の正確性・十分性について責任を負いかねます。\nお客様ご自身の責任により薬剤情報等をご利用ください。\nまた、より詳細な情報を望まれる場合は、担当の医師または薬剤師にお尋ねください。',
    NotesOfOverTheCounterContent:
      '当サイトに掲載する薬の情報・画像（以下「薬剤情報等」といいます。）は「セルフメディケーション・データベースセンター」の提供によるものです。\n当社は薬剤情報等の正確性・十分性について責任を負いかねます。\nお客様ご自身の責任により薬剤情報等をご利用ください。',
  },
};
